import { FacebookAuthProvider, signInWithPopup } from "firebase/auth";
import { auth } from "../firebase";
import { socialLoginUser } from "../redux/auth/auth.actions";
import { toast } from "react-toastify";

export const facebookLogin = async (dispatch, navigate) => {
  const provider = new FacebookAuthProvider();
  try {
    const result = await signInWithPopup(auth, provider);
    console.log("result from facebook login", result);
    // Dispatch login action with Facebook user data
    const facebookUser = result.user;
    const loginData = {
      email: facebookUser.email,
      name: facebookUser.displayName,
      socialId: facebookUser.uid,
      socialType: "F",
      os: "web",
    };

    // Dispatch login action
    const loginResponse = await dispatch(socialLoginUser(loginData, navigate));

    // Check if login was successful
    if (loginResponse?.payload?.status === 200 || loginResponse?.payload?.status === 201) {
      const profileData = loginResponse?.payload?.data;

      if (!profileData?.nation_country?.id && !profileData?.gender?.name && !profileData?.city?.id && !profileData?.region_state?.id && !profileData?.dob?.date && !profileData?.education?.name && !profileData?.civilState?.name) {
        const language = localStorage.getItem("language") || "English";
        toast.success(
          language === "Italian"
            ? "Completa il tuo profilo per continuare."
            : "Please complete your profile to continue."
        );
        navigate("/complete-profile");
      } else {
        // Check for stored redirect path first
        const storedRedirectPath = localStorage.getItem('redirectAfterLogin');
        if (storedRedirectPath) {
          localStorage.removeItem('redirectAfterLogin'); // Clear the stored path
          navigate(storedRedirectPath);
        } else {
          navigate("/");
        }
      }
    }
  } catch (error) {
    console.error("Facebook Login Error:", error);
    toast.error("Login failed. Please try again.");
  }
};
